import { render, staticRenderFns } from "./DocumentsDeleteTableComponent.vue?vue&type=template&id=5914ef23&scoped=true&"
import script from "./DocumentsDeleteTableComponent.vue?vue&type=script&lang=js&"
export * from "./DocumentsDeleteTableComponent.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsDeleteTableComponent.vue?vue&type=style&index=0&id=5914ef23&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5914ef23",
  null
  
)

export default component.exports